import { baseURL } from "../../utils/misc";


 export const getPlantingMaterialTypes = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/plantingrecords/planting-material-types`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Planting Material Types!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};


export const getTreatmentTypesBeforePlanting = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/plantingrecords/treatment-types-before-planting`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Treatment Types Before Planting!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};

export const getSourcesOfPlantingMaterials = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/plantingrecords/sources-of-planting-materials`, requestOptions)
    .then((response) => { 
      if (!response.ok) {
        return;
      }
      
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching Source Of Planting Materials!", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
